/**
 * 활성유형 게이트 — 서버 공통 에러코드(SWITCH_REQUIRED / ROLE_REQUIRED) 클라 공통 처리.
 * (백엔드 플랜: muyeon-backend/docs/active-role-module-plan.md)
 *
 *  - 모든 API 요청에 X-Active-Type 헤더 자동 첨부(인터셉터에서 호출)
 *  - SWITCH_REQUIRED 응답 → 전환 확인 모달(ActiveTypeGateHost) → 확인 시 전환 후 원요청 재시도
 *  - ROLE_REQUIRED 응답 → 역할 추가/인증 유도 모달(호스트가 처리)
 */
const ACTIVE_KEY = "muyeon.activeType";

export const getActiveTypeHeader = () => {
  try {
    return localStorage.getItem(ACTIVE_KEY) || "GENERAL";
  } catch {
    return "GENERAL";
  }
};

export const ROLE_LABELS = {
  TEACHER: "강사",
  DANCER: "무용수",
  ACADEMY: "학원·원장",
  TEAM: "공연팀·기획자",
  SPACE: "공간 보유자",
  GENERAL: "일반",
};

// SWITCH_REQUIRED → 호스트 모달에 확인 요청. 확인(전환 완료) 시 true 로 resolve.
//  호스트 미마운트(초기 렌더 전 등)면 즉시 false — 기존 에러 흐름으로 폴백.
export const requestSwitchConfirm = (errorBody) =>
  new Promise((resolve) => {
    const ev = new CustomEvent("muyeon:switch-required", {
      detail: { body: errorBody, resolve },
    });
    window.dispatchEvent(ev);
    // 호스트가 detail.claimed 를 세워주지 않으면 처리자 없음 → 폴백
    if (!ev.detail.claimed) resolve(false);
  });

export const notifyRoleRequired = (errorBody) => {
  window.dispatchEvent(
    new CustomEvent("muyeon:role-required", { detail: { body: errorBody } }),
  );
};

/* ── 무용수 레슨 활동 차단(2026-09-26) ──
 *  무용수 유형으로 활동 중이면 레슨 요청·예약(고객)도, 레슨 개설·견적 응답(제공자)도 할 수 없다.
 *  (레슨으로 돈을 벌려면 강사 유형을 따야 한다 — 서버도 같은 기준으로 403)
 *  고객 쪽은 일반 유형으로 전환하고 계속하도록 서버 SWITCH_REQUIRED 와 같은 모양으로 확인을 띄운다. */
export const LESSON_REQUEST_SWITCH_MESSAGE = "무용수 유형에서는 레슨을 요청·예약할 수 없어요. 일반 유형으로 전환하고 계속할까요?";
export const LESSON_PROVIDE_ROLE_MESSAGE = "레슨 개설·견적 응답은 강사·학원 원장 유형에서만 이용할 수 있어요.";

/** 레슨 요청·예약 직전 확인. 무용수가 아니면 바로 true, 무용수면 일반 전환 확인 결과(true=전환됨). */
export const ensureLessonCustomer = (url = "/quotes") => {
  if (getActiveTypeHeader() !== "DANCER") return Promise.resolve(true);
  return requestSwitchConfirm({
    code: "SWITCH_REQUIRED",
    message: LESSON_REQUEST_SWITCH_MESSAGE,
    data: { required: ["GENERAL"], active: "DANCER", suggested: "GENERAL" },
    request: { url },
  });
};
